import React from "react";
import { Button } from "react-bootstrap";
import ProtectedButton from "../RBAC/ProtectedButton";

export default function MilestonePaymentModal({
    show,
    onClose,
    milestone,
    onSave,
}) {
    if (!show) return null;

    return (
        <div
            className="modal fade show d-block"
            tabIndex="-1"
            style={{
                background: "rgba(0,0,0,0.5)",
                backdropFilter: "blur(4px)",
                zIndex: 1200,
            }}
            onClick={onClose}
        >
            <div
                className="modal-dialog modal-dialog-centered"
                style={{ maxWidth: "480px", width: "90%" }}
                onClick={(e) => e.stopPropagation()}
            >
                <div
                    className="modal-content text-center p-5 rounded-4 shadow"
                    style={{
                        background: "#fff",
                        borderRadius: "16px",
                        width: "100%",
                    }}
                >
                    <img
                        src="/images/imagedrop.svg"
                        alt="Payment Illustration"
                        className="img-fluid mb-4"
                        style={{
                            maxWidth: "180px",
                            height: "auto",
                            marginLeft: "100px"
                        }}
                    />

                    <h5 className="fw-bold mb-3" style={{ color: "#071437" }}>
                        Milestone {milestone?.milestoneNumber} Payment required!
                    </h5>

                    <p className="text-muted mb-4">
                        To start the Milestone {milestone?.milestoneNumber}, you should pay{" "}
                        <strong>${milestone?.amount.toLocaleString()}</strong>
                    </p>

                    <ProtectedButton
                        permission="payMilestone"
                        onClick={onSave}
                        className="w-100 py-2 fw-semibold"
                        style={{
                            backgroundColor: "#181D4C",
                            color: "#fff",
                            borderRadius: "8px",
                            border: "none",
                            height: "48px",
                        }}
                    >
                        Pay the Milestone
                    </ProtectedButton>
                </div>
            </div>
        </div>
    );
}
